import { useMutation } from '@apollo/client';
import type { ApiOptions } from '~/api/helpers';
import { MarkAnnouncementsReadDocument } from './mark-read.generated';

// Deliberately silent: this fires from reading an announcement, so a toast either way would
// be noise. The mutation returns the user with its new unread count, which Apollo normalises
// into the cache — that is what drops the badge without waiting for AppContext's poll.
export const useMarkAnnouncementsRead = (
  options: ApiOptions<typeof MarkAnnouncementsReadDocument> = {},
) => useMutation(MarkAnnouncementsReadDocument, options);
